import { withErrorBoundary } from 'app/components/error-boundary';
import type { NavigationScreen } from 'app/types/navigation';
import { withOptionalMetrics } from 'app/utils/performance/with-metrics';
import { ChatMembersScreenComponent } from './chat-members-screen-component';
export const ChatMembersScreen: NavigationScreen<'chat-members'> = withOptionalMetrics(
  'ChatMembersScreen',
  withErrorBoundary(ChatMembersScreenComponent),
);
